<div *ngIf="booking as pBook else pploading">
  <p-table id="productReservation" #productReservation
           [value]="pBook"
           [rowHover]="true"
           [resizableColumns]="true"
           selectionMode="single"
           [(selection)]="selectedBooking"
           dataKey="DOCID"
           sortField="RESERVEDTILL"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th pSortableColumn="LOCCOMP" pResizableColumn style="width: 15% !important" class="do-not-overlay-text">Продавец <p-sortIcon field="LOCCOMP"></p-sortIcon></th>
        <th pSortableColumn="DOCNUMBER" pResizableColumn style="width: 8% !important" class="do-not-overlay-text">Счет <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
        <th pSortableColumn="DOCDATE" pResizableColumn style="width: 7% !important" class="do-not-overlay-text">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
        <th pSortableColumn="CLIENTSNAME" pResizableColumn style="width: 15% !important" class="do-not-overlay-text">Покупатель <p-sortIcon field="CLIENTSNAME"></p-sortIcon></th>
        <th pSortableColumn="INPROD" pResizableColumn style="width: auto !important" class="do-not-overlay-text">В составе <p-sortIcon field="INPROD"></p-sortIcon></th>
        <th pSortableColumn="ORDERED" pResizableColumn style="width: 8% !important" class="do-not-overlay-text">В счете <p-sortIcon field="ORDERED"></p-sortIcon></th>
        <th pSortableColumn="SHIPPED" pResizableColumn style="width: 8% !important" class="do-not-overlay-text">Отгружено <p-sortIcon field="SHIPPED"></p-sortIcon></th>
        <th pSortableColumn="DEBTS" pResizableColumn style="width: 8% !important" class="do-not-overlay-text">Долг <p-sortIcon field="DEBTS"></p-sortIcon></th>
        <th pSortableColumn="MANUED" pResizableColumn style="width: 8% !important" class="do-not-overlay-text">В производстве <p-sortIcon field="MANUED"></p-sortIcon></th>
        <th pSortableColumn="RESERVEDTILL" pResizableColumn style="width: 10% !important" class="do-not-overlay-text">Резерв до <p-sortIcon field="PARTNAME"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pBook>
      <tr [pSelectableRow]="pBook">
        <td style="width: 3rem">
          <button type="button" pButton pRipple pTooltip="Содержимое документа"
                  [pRowToggler]="pBook" class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
          </button>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{pBook.LOCCOMP | pipetrimstr }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <a [routerLink]="['/edit-document', 1, pBook.DOCID]">{{pBook.DOCNUMBER }}</a>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          {{pBook.DOCDATE | date:'dd.MM.yyyy' }}
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{pBook.CLIENTSNAME | pipetrimstr }}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <a [routerLink]="['/edit-product', pBook.PRODID]">{{pBook.INPROD | pipetrimstr }}</a>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{pBook.ORDERED | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{pBook.SHIPPED | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{pBook.DEBTS | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{pBook.MANUED | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{pBook.RESERVEDTILL | pipetrimstr }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-doc>
      <tr>
        <td colspan="11">
          <div class="p-p-2">
            <app-document-content-table [selectedDocumentId]="doc.DOCID" [showFooterTotal]="true"></app-document-content-table>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="11">На данный момент нет резервирования</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #pploading>
  <p>Информация о резервировании загружается...</p>
</ng-template>
